'use client';

import { c as _c } from "react/compiler-runtime";
import { useSignedMutation } from '@achra/sdk/react';
import { useQueryClient } from '@tanstack/react-query';
import type { EnsureRolesResult } from '@achra/sdk';
interface BecomeAnOperatorInput {
  /** The builder's display name, so the offering drive is named consistently. */
  name?: string;
}

/**
 * Promotes an existing builder to an operator.
 *
 * Idempotent + role-aware: `ensure(['operator'])` detects the already-present
 * builder workspace and skips it — it creates ONLY the service-offering drive
 * and flips `isOperator` on the existing builder profile. No builder duplicate.
 *
 * On success it invalidates the drives lists (so the new offering drive shows
 * up) and the builder profile (so `isOperator` flips and this banner hides).
 */
function useBecomeAnOperator() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["GetBuilderDrives"]
        });
        queryClient.invalidateQueries({
          queryKey: ["GetBuilderDrivesSuspense"]
        });
        queryClient.invalidateQueries({
          queryKey: ["BuilderProfile"]
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useSignedMutation(t0);
}
async function _temp(t0, t1) {
  const {
    name
  } = t0;
  const {
    signer,
    address,
    client
  } = t1;
  return client.workspaces.ensure(["operator"], {
    signer,
    address,
    name
  });
}
export { useBecomeAnOperator };
export type { BecomeAnOperatorInput };